import { Component, Input } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { IUser } from '../../../shared/models/user';
import { IConnectLinkItem } from '../shared/models/connect-link-item';
import { catchError, filter, map, of, Subscription, switchMap, take } from 'rxjs';
import { ConfigurationService } from '../../../shared/services/configuration.service';
import { IAppUrls } from '../../../shared/models/app-urls';
import { UserUtility } from '../../../shared/utilities/user-utility';



@Component({
    selector: 'app-connect-links',
    templateUrl: './connect-links.component.html',
    styleUrl: './connect-links.component.scss',
    standalone: false
})
export class ConnectLinksComponent {

  @Input() id: string = '';

  connectLinkItems: IConnectLinkItem[] = [];
  subscriptions: Subscription = new Subscription();


  constructor(
    public _authService: AuthService,
    private _configService: ConfigurationService,
  ) {
  }

  ngOnDestroy(): void {
    if(this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize() {
    const userSubscription = this._authService.currentUserSubject
    .pipe(
      filter(user => !!user),
      take(1),
      switchMap((user) => {
        if(user) {
          return this._configService.getAppUrls().pipe(
            map(appUrls => {
              if(appUrls) {
                const connectLinkItems = this.getConnectLinks(user, appUrls);
                return connectLinkItems;
              } else {
                return [];
              }
            }),
            catchError(err => {
              return of([]);

              // TODO: Log to SumoLogic;

            })
          );
        } else {
          return of([]);
        }
      })
    )
    .subscribe({
      next: (result) => {
        this.connectLinkItems = result;
      },
      error: (error) => {
        this.connectLinkItems = [];

        // TODO: Log to SumoLogic;
      }
    });


    this.subscriptions.add(userSubscription);
  }

  getConnectLinks(currentUser: IUser, appUrls: IAppUrls): IConnectLinkItem[] {
    const isInternalUser = UserUtility.isInternalUser(currentUser);
    const userIsAboveMoP = UserUtility.userIsAboveMoP(currentUser);
    const isOktaUser = this._authService.isOktaUser;
    const standardsAcademyUrl = isOktaUser ? appUrls.newStandardsAcademyUrl : appUrls.standardsAcademy;
    const isoSignInUrl = isOktaUser ? appUrls.isoSignInUrl :'https://isolutions.iso.org/portal/';
    const connectLinkItems: IConnectLinkItem[] = [
      {
        id: 'link-public-comment',
        displayText: 'Drafts Open for Public Comment',
        href: UserUtility.getUsersPcmsUrl(isInternalUser, appUrls.pcmsUrl, isOktaUser),
        routerLink: '',
        action: false,
        show: true,
      },
      {
        id: 'link-international-participation-platform',
        displayText: 'International Participation Platform (Meetings)',
        href: appUrls.internationalParticipationPlatformUrl ?? '',
        routerLink: '',
        action: false,
        show: userIsAboveMoP
      },
      {
        id: 'link-isolutions',
        displayText: 'ISOlutions',
        href: isoSignInUrl,
        routerLink: '',
        action: false,
        show: userIsAboveMoP
      },
      {
        id: 'link-iso',
        displayText: 'ISO - International Organization for Standardization',
        href: 'https://www.iso.org/home.html',
        routerLink: '',
        action: false,
        show: true
      },
      {
        id: 'link-iec',
        displayText: 'IEC - International Electrotechnical Commission',
        href: 'https://www.iec.ch/homepage',
        routerLink: '',
        action: false,
        show: true
      },
      {
        id: 'link-committee-member-view-of-sim',
        displayText: "Committee Member's View of SIM",
        href: '',
        routerLink: '/sa-library',
        action: false,
        show: isInternalUser
      },
      {
        id: 'link-standards-academy',
        displayText: 'Standards Academy',
        href: standardsAcademyUrl ?? '',
        routerLink: '',
        action: false,
        show: userIsAboveMoP
      },
      {
        id: 'link-sa-website',
        displayText: 'Standards Australia Website',
        href: 'https://www.standards.org.au',
        routerLink: '',
        action: false,
        show: true
      },
      {
        id: 'link-construction-dictionary',
        displayText: 'Construction Dictionary',
        href: 'https://www.constructiondictionary.com.au/',
        routerLink: '',
        action: false,
        show: true
      },
      {
        id: 'link-reports',
        displayText: 'Reports',
        href: '',
        routerLink: '/reports',
        action: false,
        show: true
      },
      {
        id: 'link-guides-and-videos',
        displayText: 'User Guides and Videos',
        href: '',
        routerLink: '/guides-and-videos',
        action: false,
        show: true
      },
      {
        id: 'link-submit-proposal',
        displayText: 'Submit a Proposal',
        href: appUrls.projectProposalPlatform?? '',
        routerLink: '',
        action: false,
        show: true
      },
      {
        id: 'link-standards-australia-acronyms-abbreviations',
        displayText: 'Standards Australia Acronyms and Abbreviations',
        href: 'https://www.standards.org.au/documents/standards-australia-acronyms-and-abbreviations',
        routerLink: '',
        action: false,
        show: true
      }
    ];
    return connectLinkItems;
  }
}
